import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { API_URLS } from '../../../../../../../environments/env-routes';
import { NodesService } from '../services/nodes.service';
import { SiteContextService } from 'src/shared/services/site/site-context.service';
import { NodeContextService } from 'src/shared/services/node/node-context.service';


@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit, OnDestroy {
  public creator: string;
  public description: string;
  public size: any;
  public modifier: string;
  public creationDate: string;
  public modificationDate: string;
  public loadingPage: boolean;
  public blobFile: any;
  public mimeType: string;
  public selectedNode: any;
  public path: any;
  public properties: any;
  public originalMimeType: string;
  @Input() isPublic = false;
  public documentBreadcrumbParentsArray$: Observable<any>;
  private childId: string;
  private parentId: string;
  private name: string;
  private order: string;
  public siteId: string;
  @Input() private isCalledAsRoute = true;
  @Input('idFile') private fileIdCalledAsComponent;
  @Input('siteId') private paramSiteId = null;
  @Output() private goBack = new EventEmitter();

  constructor(private api: APIHelper,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private storage: StorageService,
    private siteContext: SiteContextService,
    private nodeContext: NodeContextService,
    private nodeService: NodesService) {
  }

  ngOnInit() {
    if (this.isCalledAsRoute) {
      this.order = null;

      this.siteId = this.activatedRoute.parent.snapshot.params.siteId;

      this.activatedRoute.params.subscribe((params) => {
        if (!params.childId || !params.nodeId || !this.siteId) {
          this.goToSites();
          return;
        }

        if (params.actualOrder) {
          this.order = params.actualOrder;
        }

        this.childId = params.childId;
        this.parentId = params.nodeId;
        this.initialize(params.childId);
      });
    } else {
      this.siteId = this.paramSiteId;
      this.initialize(this.fileIdCalledAsComponent);
    }
  }

  ngOnDestroy() {
    this.siteContext.setCurrentSite(null);
    this.nodeContext.setCurrentNode(null);
  }

  public goToSites() {
    this.router.navigate(['/', 'home', 'my-libraries']);
  }

  public onExit() {
    if (this.isCalledAsRoute) {
      if (this.order !== null) {
        this.router.navigate(['/', 'home', 'my-libraries', 'sites', this.siteId, 'lib', this.parentId]);
      } else {
        this.router.navigate(['/', 'home', 'my-libraries', 'sites', this.siteId, 'lib', this.parentId]);
      }
    } else {
      this.goBack.emit();
    }
  }


  private initialize(id) {
    this.loadingPage = true;
    let childrenRoute: string;
    if (!this.isPublic) {
      childrenRoute = API_URLS.nodes.nodes.replace(':nodeId', id);
    } else {
      childrenRoute = API_URLS.sharedLink.getLink.replace(':sharedId', id);
    }
    const args = 'include=allowableOperations';
    //TO GET PATH OF FILE =>  TO IMPROVE
    this.nodeService.resolveOne(id).then((result) => {
      this.path = result.path;
    })
    this.api.requestApi({ action: childrenRoute, queryArgs: args })
      .then((res) => {
        if (this.isPublic) {
          this.childId = res.nodeId;
        }
        this.selectedNode = res;
        this.nodeContext.setCurrentNode(res);
        this.documentBreadcrumbParentsArray$ = fromPromise(this.nodeService.getNodeParentsArray(res));
        this.nodeService.getSite(res.id).then(site => {
          this.siteContext.setCurrentSite(site);
        });
        this.mimeType = this.getType(res.content.mimeType);
        this.originalMimeType = res.content.mimeType;
        this.name = res.name;
        if (!this.isPublic) {
          this.nodeContext.setCurrentNode(res);
          this.documentBreadcrumbParentsArray$ = fromPromise(
            this.nodeService.getNodeParentsArray(res)
          );
          this.nodeService.getSite(res.id).then(site => {
            this.siteContext.setCurrentSite(site);
          });
          this.creator = res.createdByUser.displayName;
          this.description = res.properties['cm:description'];
          this.size = res.content.sizeInBytes;
          this.modifier = res.modifiedByUser.displayName;
          this.creationDate = res.createdAt;
          this.modificationDate = res.modifiedAt;
          this.properties = res.properties;

        }
        const token = this.storage.getAsync({ key: "token" });
        let promise = null;
        if (this.mimeType !== 'DOCX' && this.mimeType !== 'PPT' && this.mimeType !== 'EXCEL') {
          promise = this.nodeService.loadFile(id, token, this.isPublic);
        } else {
          this.mimeType = this.getType(res.content.mimeType);
          promise = this.loadConvertedFile(id, token);
        }

        return promise;
      })
      .then((result) => {
        this.blobFile = result;
      })
      .catch((result) => {
        this.mimeType = 'INCONNU';
      })
      .finally(() => this.loadingPage = false);
  }

  private loadConvertedFile(nodeId, token): Promise<any> {

    let contentRoute: string;
    let args2: string;
    let headerObject = {};
    if (!this.isPublic) {
      contentRoute = API_URLS.nodes.convert.replace(':nodeId', nodeId);
      args2 = '?alf_ticket=' + token + '&attachment=false' + '&c=force';

      const bearer = this.storage.getAsync({ key: 'bearer' });

      headerObject = {
        Authorization: 'Basic ' + bearer
      };
    } else {
      args2 = '?alf_ticket=' + token + '&attachment=false' + '&c=force';
      contentRoute = API_URLS.sharedLink.convertToPdf.replace(':sharedId', nodeId);
    }
    return this.http
      .get(this.api.url + contentRoute + args2, {
        headers: new HttpHeaders(headerObject),
        responseType: 'blob'
      })
      .toPromise();
  }

  private getType(mimeType): string {
    let result = 'INCONNU';
    const arr = mimeType.split('/');
    const main = arr[0];

    if (main === 'text') {
      result = 'TXT';
    } else if (main === 'image') {
      result = 'IMG';
    } else if (main === 'video') {
      result = 'MEDIA';
    } else if (main === 'audio') {
      result = 'MEDIA';
    } else if (main === 'application') {
      const appli = arr[1];

      if (appli === "vnd.ms-excel" || appli === "vnd.openxmlformats-officedocument.spreadsheetml.sheet" || appli === "vnd.ms-excel.sheet.macroenabled.12") {
        result = "EXCEL";
      } else if (appli === "vnd.ms-powerpoint" || appli === "vnd.openxmlformats-officedocument.presentationml.presentation") {
        result = "PPT";
      } else if (appli === "msword" || appli === "vnd.openxmlformats-officedocument.wordprocessingml.document") {
        result = "DOCX";
      } else if (appli === "pdf") {
        result = "PDF";
      }
    }

    return result;
  }

  goToNode(n) {
    let documentUrl = [];
    if (n.isFile) {
      documentUrl = ['/home/my-libraries', 'sites', this.siteId, 'lib', n.parentId, 'preview', n.id];
    }
    if (n.isFolder) {
      documentUrl = ['/home/my-libraries/sites', this.siteId, 'lib', n.id];
    }
    this.router.navigate(documentUrl);
  }

}
